/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS17 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_16;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_17;
    },
    getDownloadName() {
      return ns.IOS17.nice_name;
    },
  });

  Object.assign(IOS17, {
    slug: `ios_17`,
    nice_name: `iOS 17 adoption`,
    description: `How quickly are consumers upgrading to iOS 17?`,
  });
  ns.IOS17 = IOS17;
});

}.call(window));